const validate = values => {
  const errors = {};

  if (!values.eventDate) {
    errors.eventDate = "Обов'язково";
  }

  if (!values.fullName) {
    errors.fullName = "Обов'язково";
  }

  if (!values.email) {
    errors.email = "Обов'язково";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Неіснуюча пошта';
  }

  if (!values.phone) {
    errors.phone = "Обов'язково";
  }

  return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/validate.js